import { downloadCSV } from '../../../core/utils/download.js';
import { CSS_DOWNLOAD_FILENAME } from '../../core/constants.js';
import { CategoricalBarChartData } from '../types/categorical-bar-chart.js';
import { formatCSV } from './format-csv.js';

/**
 * Builds CSV from Caregorical
 *
 * @param series - Categorical data
 */
export const buildAndDownloadCsv = (
  categoricalData: CategoricalBarChartData[],
) => {
  const csvString = formatCSV(categoricalData);
  downloadCSV(csvString, CSS_DOWNLOAD_FILENAME);
};
